/** A directly granted report has path === start, with its ID outside the path. */
export const getHomeworkAssignmentRoot = (report: { id: string; path: string; start: string }) => {
    if (!report.path || !report.start || !report.id) throw new Error("과제 배정 경로가 올바르지 않습니다.");
    const relativePath = report.path === report.start
        ? ""
        : report.path.startsWith(`${report.start}/`) ? report.path.slice(report.start.length + 1) : null;
    if (relativePath === null) throw new Error("과제 배정 경로가 올바르지 않습니다.");
    return { path: report.start, id: relativePath ? relativePath.split("/")[0] : report.id };
};
